import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-chatbot',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chatbot.component.html',
  styleUrl: './chatbot.component.scss'
})
export class ChatbotComponent {
  private readonly chatUrl = 'http://10.130.3.5:5010/';
  isOpen = false;
  loaded = false;
  chatSrc: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  toggle(): void {
    this.isOpen = !this.isOpen;
    // Load iframe lazily on first open
    if (this.isOpen && !this.chatSrc) {
      this.chatSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.chatUrl);
    }
  }
}
